import { render } from "./PubApi.vue?vue&type=template&id=3d3811b4&scoped=true"
import script from "./PubApi.vue?vue&type=script&lang=js"
export * from "./PubApi.vue?vue&type=script&lang=js"

import "./PubApi.vue?vue&type=style&index=0&id=3d3811b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d3811b4"

export default script